'use strict';

import Timeline from './timeline';
export default Timeline;
